import type { BetType } from '../../store/slices/bets/types';

import { SessionStorage } from './SessionStorage';

enum CoreSessionStorageProps {
  LastMasterVolume = 'lastMasterVolume',
  LastPositiveMasterVolume = 'lastPositiveMasterVolume',
  IsChatClosed = 'isChatClosed',
  LastBet = 'lastBet',
}

interface CoreSessionStorageAPI {
  setLastMasterVolume(value: number): void;
  setLastPositiveMasterVolume(value: number): void;
  setIsChatClosed(value: boolean): void;
  setLastBets(value: BetType, tableId: string): void;
  getLastMasterVolume(): number | null;
  getLastPositiveMasterVolume(): number | null;
  getIsChatClosed(): boolean;
  getLastBets(tableId: string): BetType | null;
}

export const CoreSessionStorage: CoreSessionStorageAPI = {
  /* 
    VOLUME 
  */
  setLastMasterVolume: (value: number): void =>
    SessionStorage.set(CoreSessionStorageProps.LastMasterVolume, Math.floor(value * 100).toString()),
  setLastPositiveMasterVolume: (value: number): void =>
    SessionStorage.set(CoreSessionStorageProps.LastPositiveMasterVolume, Math.floor(value * 100).toString()),
  getLastMasterVolume: (): number | null => {
    const storedValue = SessionStorage.get(CoreSessionStorageProps.LastMasterVolume);
    if (storedValue) {
      return storedValue ? parseInt(storedValue) / 100 : null;
    }
    return null;
  },
  getLastPositiveMasterVolume: (): number | null => {
    const storedValue = SessionStorage.get(CoreSessionStorageProps.LastPositiveMasterVolume);
    if (storedValue) {
      return storedValue ? parseInt(storedValue) / 100 : null;
    }
    return null;
  },

  /* 
    CHAT 
  */
  setIsChatClosed: (value: boolean): void => SessionStorage.set(CoreSessionStorageProps.IsChatClosed, value.toString()),
  getIsChatClosed: (): boolean => {
    const storedValue = SessionStorage.get(CoreSessionStorageProps.IsChatClosed);
    return storedValue === 'true' || storedValue === null || storedValue === undefined;
  },

  /* 
    GAME SPECIFICS 
  */
  setLastBets: (value: BetType, tableId: string): void =>
    SessionStorage.set(CoreSessionStorageProps.LastBet + '-' + tableId, JSON.stringify(value)),

  getLastBets: (tableId: string): BetType | null => {
    const storedValue = SessionStorage.getJson<BetType>(CoreSessionStorageProps.LastBet + '-' + tableId);
    return storedValue ?? null;
  },
};
